import React, { useState, useEffect } from "react";
import moment from "moment";

import DatePick from "src/components/DatePick/DatePick";
import Button from "src/components/Button/Button";

import styles from  "./SubSearchInput.module.scss";

interface IProps {
    label: string,
    placeholder: string,
    isLast?: boolean,
    options?: string[],
    isDate: boolean,
    value: string | Date,
    onChange?(value: string | Date): void,
    className?: string
}

const SubSearchInput: React.FC<IProps> = (props) => {
  const [showOptions, setShowOptions] = useState<boolean>(false);
  const [currentOption, setCurrentOption] = useState<string>(typeof props.value === "string" ? props.value : "");
  const [selectedDate, setSelectedDate] = useState<boolean>(false);
  const [startDate, setStartDate] = useState<Date>(new Date());

  const toggleShowOptions = (value?: boolean) => {
    setShowOptions(value ? value : !showOptions);
  }

  useEffect(() => {
    if (props.onChange && !props.isDate) {
      props.onChange(currentOption);
    }
  }, [currentOption]);

  useEffect(() => {
    if (props.onChange && props.isDate) {
      props.onChange(startDate);
      setSelectedDate(true);
    }
  }, [startDate]);

  return (
    <div
      onClick={() => {
        if ((props.isDate === false) || (!showOptions && props.isDate)) {
          toggleShowOptions();
        }
      }}
      className={props.isLast ? `${styles.isLast} ${styles.SubSearchInput} ` + (props.className ? `${props.className}` : "") : `${styles.SubSearchInput}` + (props.className ? `${props.className}` : "")}
    >
        <span className={styles.label}>{props.label}</span>
        <span className={styles.placeholder}>
          {props.isDate === false && <>{currentOption === "" ? props.placeholder : currentOption}</>}
          {props.isDate === true && <>{selectedDate ? moment(startDate).format("MMMM Do, YYYY") : props.placeholder}</>}
        </span>
        {showOptions && props.isDate && <div className={`${styles.options} ${styles.date} `}>
          <DatePick
            className={styles.startDate}
            innerClassName={styles.innerStartDate}
            label="Start Date"
            value={startDate}
            onChange={(d: any) => {
              setStartDate(d);
              toggleShowOptions();
            }}
            open={true}
          />
        </div>}
        {showOptions && !props.isDate && <div className={styles.options}>
          {props.options && <ul>
            {props.options.map((opt: string, index: number) => {
              return(<li key={index} onClick={() => { setCurrentOption(opt); }}>{opt}</li>);
            })}
          </ul>}
        </div>}
    </div>
  );
};

export default SubSearchInput;